import React from 'react';
import { prop } from 'ramda';
import VersionsTree from '../../../components/VersionTree/VersionsTree';
import { associateVersions } from '../../../lib/versions';
import withUser from '../../../withUser';

const OfferList = ({
  style,
  userCanEdit,
  offers,
  setRefetch,
  user
}) => {
  return (
    // eslint-disable-next-line no-restricted-syntax
    <div style={style}>
      <VersionsTree
        items={associateVersions(offers, 'version.itemRootId')}
        editLinkPattern="/offre/:itemId/edition"
        suppressionLabel="Voulez-vous vraiment supprimer cette offre ?"
        archiveLabel="Voulez-vous vraiment archiver cette offre ?"
        restoreLabel="Voulez-vous vraiment rétablir cette offre ?"
        descriptionArchive={<div><p className="pb-4">Cette offre sera archivée et ne sera plus modifiable ni visible dans la liste principale.</p><p>Elle restera toutefois accessible si elle est toujours utilisée dans un projet et sera disponible dans la liste des archives.</p></div>}
        userCanEdit={userCanEdit}
        nameField="offerName"
        setRefetch={setRefetch}
        userId={prop('userId', user)}
        isOffer
      />
    </div>
  );
};

OfferList.defaultProps = { style: { marginTop: 16 } };

export default withUser(OfferList);
